import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaioutstationcab() {



    const cardData = {

        keyword: "Mumbai Outstation Cabs",

        headingDescription:
            "Mumbai Airport Cab offers safe, reliable, and comfortable Mumbai Outstation Cabs for family vacations, business trips, pilgrimage tours, weekend getaways, and long-distance travel across Maharashtra and neighboring states. We provide well-maintained Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus options driven by experienced chauffeurs to ensure a smooth and enjoyable journey. With doorstep pickup across Mumbai, Mumbai Airport transfers, one-way and round-trip bookings, customizable travel plans, 24/7 customer support, and transparent pricing, we make outstation travel convenient and stress-free for individuals, families, and large groups seeking comfortable road travel from Mumbai.",

        topPlaces: [
            {
                title: "Lonavala & Khandala",
                description:
                    "Lonavala and Khandala are among the most popular weekend destinations from Mumbai, famous for scenic valleys, waterfalls, historic caves, and pleasant weather. Travelers enjoy attractions such as Tiger Point, Bhushi Dam, Rajmachi Point, and Karla Caves. The smooth expressway route and beautiful Sahyadri landscapes make this destination perfect for family holidays, corporate outings, and short road trips throughout the year."
            },
            {
                title: "Mahabaleshwar & Panchgani",
                description:
                    "Mahabaleshwar and Panchgani are renowned hill stations known for strawberry farms, beautiful valleys, ancient temples, and panoramic viewpoints. Visitors can explore Venna Lake, Arthur's Seat, Mapro Garden, Table Land, and local markets while enjoying the cool climate. Outstation cab travel from Mumbai provides a relaxed and comfortable way to experience these scenic destinations with family and friends."
            },
            {
                title: "Shirdi & Shani Shingnapur",
                description:
                    "Shirdi is one of India's most important pilgrimage destinations, attracting millions of Sai Baba devotees every year. Many travelers combine their visit with Shani Shingnapur, the famous temple dedicated to Lord Shani. Mumbai outstation cabs offer flexible itineraries for darshan, family pilgrimages, and spiritual journeys with comfortable highway travel and convenient stops along the route."
            },
            {
                title: "Nashik & Trimbakeshwar",
                description:
                    "Nashik is a spiritual and cultural city famous for Trimbakeshwar Jyotirlinga, Panchavati, ancient temples, vineyards, and the sacred Godavari River. It attracts pilgrims, wine enthusiasts, and history lovers alike. Outstation cab services from Mumbai provide an excellent option for visiting both religious and tourist attractions comfortably during a single trip."
            },
            {
                title: "Alibaug & Murud",
                description:
                    "Alibaug and Murud are beautiful coastal destinations known for sandy beaches, sea forts, water sports, and peaceful surroundings. Tourists visit Kolaba Fort, Murud-Janjira Fort, Kashid Beach, and local fishing villages for a relaxing holiday. Mumbai outstation cabs make beach vacations convenient with direct doorstep pickup and flexible sightseeing schedules."
            },
            {
                title: "Goa",
                description:
                    "Goa remains one of the most sought-after long-distance road trip destinations from Mumbai, offering beautiful beaches, Portuguese architecture, nightlife, water sports, churches, and seafood cuisine. Popular attractions include Baga Beach, Calangute, Fort Aguada, Basilica of Bom Jesus, and Dudhsagar Falls. Comfortable outstation cabs make the long journey enjoyable for families and groups."
            },
            {
                title: "Aurangabad, Ajanta & Ellora",
                description:
                    "Aurangabad is famous for its rich historical heritage and proximity to the UNESCO World Heritage Sites of Ajanta and Ellora Caves. Travelers can also visit Bibi Ka Maqbara, Daulatabad Fort, and Grishneshwar Jyotirlinga. Mumbai outstation cab services allow visitors to explore history, spirituality, and architecture through a comfortable multi-day road journey."
            },
            {
                title: "Matheran",
                description:
                    "Matheran is a charming eco-sensitive hill station where motor vehicles are restricted, creating a peaceful atmosphere for visitors. Popular attractions include Panorama Point, Charlotte Lake, Echo Point, and horse riding trails through lush forests. Outstation cabs from Mumbai provide easy access to the base point, making family trips and weekend escapes highly convenient."
            },
            {
                title: "Ganpatipule & Ratnagiri",
                description:
                    "Ganpatipule and Ratnagiri are famous Konkan destinations known for pristine beaches, the revered Ganpati temple, sea forts, and traditional coastal culture. Visitors enjoy beautiful coastal drives, fresh seafood, mango orchards, and peaceful seaside landscapes. Mumbai outstation cab services offer a comfortable and scenic journey through the picturesque Konkan region."
            },
            {
                title: "Udaipur",
                description:
                    "Udaipur, the City of Lakes, is a popular long-distance destination from Mumbai known for royal palaces, historic forts, cultural heritage, and beautiful lakes. Attractions such as City Palace, Lake Pichola, Fateh Sagar Lake, Jag Mandir, and Saheliyon Ki Bari make it a memorable travel experience. Outstation cab travel provides flexibility for sightseeing while enjoying Rajasthan's rich history and hospitality."
            }
        ],



        services: [
            {
                name: "Mumbai Outstation Cabs",
                description: "Mumbai Airport Cab offers Mumbai Outstation Cabs for safe, comfortable, and affordable long-distance travel across Maharashtra and India. Our fleet includes Sedan, SUV, Ertiga, Innova Crysta, and premium vehicles for family trips, business travel, religious tours, and holiday packages. Enjoy 24x7 cab booking, professional drivers, doorstep pickup, transparent pricing, and flexible one way and round trip options for a hassle-free outstation journey."
            },
            {
                name: "Best Outstation Cab Service in Mumbai",
                description: "Book the Best Outstation Cab Service in Mumbai with Mumbai Airport Cab for reliable intercity travel. We provide clean AC vehicles, experienced chauffeurs, on-time service, and customized travel plans for business trips, family vacations, and long-distance journeys."
            },
            {
                name: "Outstation Cab Booking Mumbai",
                description: "Mumbai Airport Cab provides Outstation Cab Booking Mumbai with instant confirmation and multiple vehicle options. Choose from Sedan, SUV, Ertiga, Innova Crysta, and luxury cabs for one way and round trip travel at competitive prices."
            },
            {
                name: "Outstation Cab Service in Mumbai",
                description: "Our Outstation Cab Service in Mumbai is designed for comfortable long-distance travel with professional drivers, well-maintained vehicles, flexible pickup locations, and 24x7 customer support for a stress-free journey."
            },
            {
                name: "Outstation Taxi Service in Mumbai",
                description: "Mumbai Airport Cab offers Outstation Taxi Service in Mumbai for airport transfers, holiday tours, corporate travel, and family trips. Travel safely with clean AC cabs and experienced drivers for all major destinations."
            },
            {
                name: "Cab Booking in Mumbai for Outstation",
                description: "Book Cab in Mumbai for Outstation travel with Mumbai Airport Cab for convenient and affordable intercity transportation. We provide doorstep pickup, comfortable vehicles, and flexible travel schedules."
            },
            {
                name: "Cab Service in Mumbai for Outstation",
                description: "Mumbai Airport Cab provides Cab Service in Mumbai for Outstation trips with premium travel solutions. Our vehicles are suitable for solo travelers, families, and corporate groups looking for safe and reliable transportation."
            },
            {
                name: "Car for Outstation from Mumbai",
                description: "Book a Car for Outstation from Mumbai with Mumbai Airport Cab and enjoy comfortable travel with AC vehicles, professional chauffeurs, and affordable pricing for one way and round trip journeys."
            },
            {
                name: "Car Hire for Outstation in Mumbai",
                description: "Mumbai Airport Cab offers Car Hire for Outstation in Mumbai with Sedan, SUV, Ertiga, and Innova Crysta options. Travel comfortably for business, leisure, pilgrimage, and weekend getaways."
            },
            {
                name: "Car on Rent for Outstation in Mumbai",
                description: "Book Car on Rent for Outstation in Mumbai for flexible travel plans and long-distance comfort. We provide reliable service with experienced drivers and well-maintained vehicles."
            },
            {
                name: "Cheapest Outstation Cabs from Mumbai",
                description: "Mumbai Airport Cab provides the Cheapest Outstation Cabs from Mumbai without compromising on comfort and safety. Enjoy transparent pricing, quality service, and affordable travel packages."
            },
            {
                name: "Hire a Cab in Mumbai",
                description: "Hire a Cab in Mumbai with Mumbai Airport Cab for local and outstation travel. Our services include airport transfers, family trips, corporate travel, and long-distance cab bookings."
            },
            {
                name: "Hire Cab Mumbai",
                description: "Mumbai Airport Cab offers Hire Cab Mumbai services with instant booking, affordable pricing, and a wide range of vehicles suitable for every travel requirement."
            },
            {
                name: "Mumbai Outstation Taxi",
                description: "Book Mumbai Outstation Taxi with Mumbai Airport Cab for safe and convenient intercity travel. We provide professional drivers, AC vehicles, and flexible travel schedules."
            },
            {
                name: "Outstation Cars in Mumbai",
                description: "Mumbai Airport Cab provides Outstation Cars in Mumbai with Sedan, SUV, Ertiga, and Innova Crysta options for family vacations, business trips, and religious tours."
            },
            {
                name: "Taxi Service in Mumbai for Outstation",
                description: "Our Taxi Service in Mumbai for Outstation ensures comfortable and reliable travel with experienced chauffeurs, clean vehicles, and affordable one way and round trip packages."
            },
            {
                name: "Mumbai to Outstation Cabs",
                description: "Mumbai Airport Cab offers Mumbai to Outstation Cabs for all major tourist and business destinations. Enjoy safe travel, transparent pricing, and professional service with premium vehicles."
            },
            {
                name: "Mumbai to Shirdi Cabs Round Trip",
                description: "Book Mumbai to Shirdi Cabs Round Trip with Mumbai Airport Cab for a comfortable pilgrimage journey. We provide affordable packages, AC vehicles, and experienced drivers."
            },
            {
                name: "Mumbai to Lonavala Round Trip Taxi",
                description: "Mumbai Airport Cab offers Mumbai to Lonavala Round Trip Taxi for weekend trips and family holidays with flexible itineraries and comfortable travel options."
            },
            {
                name: "Mumbai to Shirdi Round Trip Taxi Fare",
                description: "Get affordable Mumbai to Shirdi Round Trip Taxi Fare with Mumbai Airport Cab. Enjoy transparent pricing, reliable service, and comfortable vehicles for your pilgrimage."
            },
            {
                name: "Mumbai to Hyderabad Cab",
                description: "Book Mumbai to Hyderabad Cab with Mumbai Airport Cab for long-distance intercity travel. We offer Sedan, SUV, and Innova Crysta vehicles with professional drivers and flexible schedules."
            },
            {
                name: "Mumbai to Bangalore Cab",
                description: "Mumbai Airport Cab provides Mumbai to Bangalore Cab services for business and leisure travelers with safe driving, comfortable vehicles, and affordable travel packages."
            }
        ],

        tableData: [
            ["Mumbai Outstation Cabs", "Best Outstation Cab Service in Mumbai"],
            ["Outstation Cab Booking Mumbai", "Outstation Cab Service in Mumbai"],
            ["Outstation Taxi Service in Mumbai", "Cab Booking in Mumbai for Outstation"],
            ["Cab Service in Mumbai for Outstation", "Car for Outstation from Mumbai"],
            ["Car Hire for Outstation in Mumbai", "Car on Rent for Outstation in Mumbai"],
            ["Cheapest Outstation Cabs from Mumbai", "Hire a Cab in Mumbai"],
            ["Hire Cab Mumbai", "Mumbai Outstation Taxi"],
            ["Outstation Cars in Mumbai", "Taxi Service in Mumbai for Outstation"],
            ["Mumbai to Outstation Cabs", "Mumbai to Shirdi Cabs Round Trip"],
            ["Mumbai to Lonavala Round Trip Taxi", "Mumbai to Shirdi Round Trip Taxi Fare"],
            ["Mumbai to Hyderabad Cab", "Mumbai to Bangalore Cab"]
        ],




        whychoose: [
            {
                WhyChooseheading: "Reliable Mumbai Outstation Cabs",
                WhyChoosedescription: "Mumbai Airport Cab Service provides dependable Mumbai Outstation Cabs for business trips, family vacations, religious tours, airport transfers, and long-distance travel across Maharashtra and India."
            },
            {
                WhyChooseheading: "Comfortable Long Distance Travel Experience",
                WhyChoosedescription: "Our well-maintained vehicles and experienced drivers ensure a smooth, comfortable, and enjoyable journey for every passenger."
            },
            {
                WhyChooseheading: "Wide Range of Vehicle Options",
                WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to your travel requirements and group size."
            },
            {
                WhyChooseheading: "One Way and Round Trip Cab Service",
                WhyChoosedescription: "Whether you need a one-way drop, round trip booking, weekend getaway, or customized travel plan, we provide flexible travel solutions."
            },
            {
                WhyChooseheading: "Popular Tourist and Business Destinations",
                WhyChoosedescription: "We provide outstation cab services from Mumbai to Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Goa, Kolhapur, Aurangabad, and many more destinations."
            },
            {
                WhyChooseheading: "Ideal for Family and Group Travel",
                WhyChoosedescription: "Our spacious vehicles are perfect for family holidays, pilgrimage tours, corporate travel, weddings, and group outings."
            },
            {
                WhyChooseheading: "Safe and Professional Drivers",
                WhyChoosedescription: "Our trained drivers prioritize passenger safety and ensure timely pickups, secure driving, and hassle-free travel throughout the journey."
            },
            {
                WhyChooseheading: "Easy Booking and 24x7 Support",
                WhyChoosedescription: "Customers can conveniently book Mumbai Outstation Cabs through phone calls, WhatsApp, or online inquiries with dedicated support assistance."
            }
        ]
    };

    const faqData = [
        {
            question: "What are Mumbai Outstation Cabs?",
            answer: "Mumbai Outstation Cabs are taxi services available for long-distance travel from Mumbai to destinations across Maharashtra and neighboring states."
        },
        {
            question: "Which destinations are popular for Mumbai Outstation Cab travel?",
            answer: "Popular destinations include Pune, Nashik, Shirdi, Mahabaleshwar, Goa, Lonavala, Kolhapur, Aurangabad, and other tourist and business locations."
        },
        {
            question: "Can I book a one-way Mumbai Outstation Cab?",
            answer: "Yes, one-way cab services are available along with round-trip and customized travel options."
        },
        {
            question: "Do you provide cabs for multi-day tours?",
            answer: "Yes, customers can book vehicles for multi-day vacations, pilgrimage tours, business trips, and customized travel itineraries."
        },
        {
            question: "Which vehicle is suitable for family travel?",
            answer: "Ertiga, Innova Crysta, SUVs, and Tempo Travellers are popular choices for family and group travel."
        },
        {
            question: "Can I get pickup from Mumbai Airport?",
            answer: "Yes, pickup services are available from Mumbai Airport, railway stations, hotels, offices, and residential locations."
        },
        {
            question: "Do you provide corporate outstation cab services?",
            answer: "Yes, many professionals and organizations use our Mumbai Outstation Cabs for meetings, conferences, and business travel."
        },
        {
            question: "Are Tempo Travellers available for large groups?",
            answer: "Yes, Tempo Travellers and larger vehicles are available for family functions, corporate outings, and group tours."
        },
        {
            question: "Is advance booking recommended?",
            answer: "Yes, advance reservations help ensure vehicle availability and allow better travel planning."
        },
        {
            question: "How can I book a Mumbai Outstation Cab?",
            answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cab Service."
        }
    ];

    const testimonials = [
        {
            id: 1,
            name: "Mr. Rohit Mehta",
            feedback:
                "I regularly travel from Mumbai to Pune and Nashik for business meetings. Mumbai Airport Cab Service always provides punctual pickups, comfortable vehicles, and professional drivers.",
            rating: 5
        },
        {
            id: 2,
            name: "Mrs. Sneha Kulkarni",
            feedback:
                "Our family booked a Mumbai Outstation Cab for a trip to Mahabaleshwar. The journey was smooth, the vehicle was clean, and the overall experience was excellent.",
            rating: 5
        }
    ];
























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai Outstation Cabs",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-outstation-cabs.jpg",
"description": "Book Mumbai outstation cabs for comfortable and affordable travel to nearby cities and tourist destinations. Mumbai Airport Cabs offers reliable outstation taxi services with professional drivers, well-maintained vehicles, transparent pricing, and 24/7 customer support.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-outstation-cabs"
}
};







    return (
        <div>

<Helmet>
  <title>Mumbai Outstation Cabs | Best Outstation Taxi Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai outstation cabs for one-way and round-trip travel. Affordable outstation taxi service from Mumbai with professional drivers, comfortable cars, and reliable cab booking for family and business trips."
/>

<meta
 name="keywords"
 content="best outstation cab service in mumbai, outstation cab booking mumbai, outstation cab service in mumbai, outstation taxi service in mumbai, cab booking in mumbai for outstation, cab service in mumbai for outstation, car for outstation from mumbai, car hire for outstation in mumbai, car on rent for outstation in mumbai, cheapest outstation cabs from mumbai, one way outstation cab mumbai, round trip outstation taxi mumbai, outstation taxi hire mumbai, mumbai outstation car rental, outstation cab with driver mumbai"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/114.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaioutstationcab;